import React, { Component } from 'react'
import AirplaneSVG from '../../../../components/AirplaneSVG'
import './styles.css'

class TripSegmentCompact extends Component {

  render () {
    let { mainCarrierName, mainCarrierImageUrl, origin, destination, numOfStops, numOfUniqueCarriers,
          arrivalTime, arrivalDay, departureTime, departureDay, totalTripDuration } = this.props.tripSegment

    return (
      <div>
        <div class='trip-segment-compact'>
          <div class='trip-segment-compact__row1'>
            <img class='trip-segment-compact__img' alt='airline logo' src={mainCarrierImageUrl} />
            <div class='compact-segment__carrier greyTextSmall'> {mainCarrierName} {numOfUniqueCarriers > 1 && `+ ${numOfUniqueCarriers} more`} </div>
          </div>
          <div class='trip-segment-compact__row2'>
            <div class='trip-segment-compact__time-place'>
              <div class='trip-segment-compact__time'>{departureTime} <span class='greyTextSmall desktop-only'>{departureDay}</span></div>
              <div class='greyTextSmall mobile-only'>{departureDay}</div>
              <div class='trip-segment-compact__iata'>{origin}</div>
              {/* <div class='trip-segment-compact__iata greyTextSmall'>{`${originAirportCity}, ${originAirportState} (${origin})`}</div> */}
              {/* <div class='greyTextSmall'>{originAirportName}</div> */}
            </div>
            <div class='trip-segment-compact__airplane'>
              <div class='stops'>{numOfStops > 0 && (numOfStops === 1 ? `${numOfStops} stop` : `${numOfStops} stops`)}</div>
              <AirplaneSVG />
              <div class='greyTextSmall'>{totalTripDuration}</div>
            </div>
            <div class='trip-segment-compact__time-place'>
              <div class='trip-segment-compact__time'>{arrivalTime} <span class='greyTextSmall desktop-only'>{arrivalDay}</span></div>
              <div class='greyTextSmall mobile-only'>{arrivalDay}</div>
              <div class='trip-segment-compact__iata'>{destination}</div>
              {/* <div class='trip-segment-compact__iata greyTextSmall'>{`${destinationAirportCity}, ${destinationAirportState} (${destination})`}</div> */}
              {/* <div class='greyTextSmall'>{destinationAirportName}</div> */}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default TripSegmentCompact




// WEBPACK FOOTER //
// ./src/scenes/SearchResultsPage/components/TripSegmentCompact/index.js